// DEPENDENCIES ---------------------------------------------------------------- //

import React from 'react';
import * as Sentry from '@sentry/react';

import DefaultErrorFallback from '@components/Fallbacks/DefaultErrorFallback';

import { ReportingProvider } from '../providers/ReportingProvider';
import ReportingDashboardContent from '../components/ReportingDashboardContent';

// COMPONENT ---------------------------------------------------------------- //

/**
 * The shell band and the tab strip already name the surface, so the content renders `embedded`,
 * with no title row and its refresh handed to the shell header.
 */
const ReportsTab: React.FC = () => {
  return (
    <Sentry.ErrorBoundary
      fallback={({ error, resetError }) => (
        <DefaultErrorFallback
          message='Unexpected error caught at ReportsTab.tsx'
          error={error as Error}
          resetError={resetError}
        />
      )}
    >
      <ReportingProvider>
        <ReportingDashboardContent embedded />
      </ReportingProvider>
    </Sentry.ErrorBoundary>
  );
};

// EXPORT ---------------------------------------------------------------- //

export default ReportsTab;
